export const DEFAULT_THEME = {
  registerPolicyCheckbox: false,
  showRegisterForm: false,
  loginBGImage: '',
  colorPrimary: '#369D1A',
  colorPrimaryHover: '#33952c',
  borderRadius: '4px',
  colorLink: '#369D1A',
  colorLinkHover: '#33952c',
  colorLinkActive: '#33952c',
  controlHeight: '50',
  controlInteractiveSize: '24px',
  logo: 'https://www.grin.com/wp-content/uploads/2020/08/grin_logo_claim_212.svg',
  logoHeight: '62px',
  labelColor: 'black',
}

export const DEFAULT_CONFIG = {
  realm: 'grin',
  apiHost: 'api.unstable.dev.openpublishing.com',
  redirectUri: null,
}
